<template>
  <div class="block_wrap">
    <div class="col select">
      <label> {{ translate('device.group.many') }} </label>
      <tree-select
        :options="group_list"
        :flat="true"
        v-model="user_device_groups"
        :placeholder="translate('device.group.many')"
        :multiple="true"
      />
    </div>

    <div class="button_wrap" v-if="changes">
      <button
          class="btn btn-success btn-fill btn-wd"
          @click.prevent="update_profile"
      >
        save
      </button>
    </div>

  </div>
</template>
<script>

export default {
  name: "UserDeviceGroups",
  props: ['user_info'],
  data () {
    return {
      disabled_btn: false,
      user_device_groups: [],
      user_roles: []
    }
  },
  created() {
    this.user_device_groups = this.user_info.user_device_groups ? JSON.parse(JSON.stringify(this.user_info.user_device_groups)) : []
  },
  computed:{
    group_list(){
        let client = this.$store.getters.getClientById(this.user_info.client_id)
        let client_ids = client?.root ? [null, client?.id] : [client?.id]
        client_ids = [...new Set(client_ids)]
        return this.$store.getters.getTreeByClientIds(client_ids)
    },
    changes(){
      return JSON.stringify(this.user_device_groups) !== JSON.stringify(this.user_info.user_device_groups)
    },
  },
  watch:{
    "user_info.user_device_groups":{
      handler(){
        this.user_device_groups = JSON.parse(JSON.stringify(this.user_info.user_device_groups))
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    update_profile(){
      let params = {
        "user_id": this.user_info.id,
        "user_device_groups": this.user_device_groups,
        "user_simcard_groups": []
      }
      this.$http.v1.updateUserGroups(this.user_info.id, params, (response) => {
        if (response.data.code === 409) {
          this.global_notify('danger', this.translate('user.saved_error'))
          this.disabled_btn = false
        }else{
          this.global_notify('info', this.translate('user.user_saved'))
          this.user_device_groups = response.data.user_device_groups
          this.$emit('update_device_groups', response.data.user_device_groups)
        }
      })
    }
  }
}

</script>
<style lang='scss' scoped>
.block_wrap{
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .select{
    width: 80%;
    text-align: left;
    .button_wrap{
      text-align: right;
      margin-left: 10px;
      .btn{
        height: 40px;
      }
    }
  }
}

</style>
